import { useMutation } from "@tanstack/react-query";

import { uploadInstance } from "../../axios";
import { DocumentFormFields } from "@/common/types/forms/DocumentFormFields.type";
import { documentTypes } from "@/common/const";

const uploadAgreementDocument = async (
  formData: DocumentFormFields,
  companyId: number
) => {
  const form = new FormData();

  const params = {
    signedAt: formData.signedAt
      ? new Date(formData.signedAt).toISOString()
      : undefined,
    expireAt: formData.expireAt
      ? new Date(formData.expireAt).toISOString()
      : undefined,

    subType: formData.subType,
    companyId: formData.company?.id ?? companyId,
    userType: formData.userType,
    description: formData.description,
  };

  form.append("file", formData.file.file);

  if (!formData.file.fileList.length) throw new Error();

  return await uploadInstance
    .post("documents/agreement", form, {
      params,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => res.data)
    .catch((e) => {
      throw e;
    });
};
const uploadProductDocument = async (
  formData: DocumentFormFields,
  companyId: number
) => {
  const form = new FormData();

  const params = {
    productName: formData.productName,
    companyId: formData.company?.id ?? companyId,
    userType: formData.userType,
    status: formData.status,
    airxProductType: formData.airxProductType,
  };

  form.append("file", formData.file.file);

  if (!formData.file.fileList.length) throw new Error();

  return await uploadInstance
    .post("documents/product", form, {
      params,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => res.data)
    .catch((e) => {
      throw e;
    });
};
const uploadOtherDocument = async (
  formData: DocumentFormFields,
  companyId: number
) => {
  const form = new FormData();

  const params = {
    documentName: formData.documentName,
    status: formData.status,
    companyId: formData.company?.id ?? companyId,
    userType: formData.userType,
  };

  form.append("file", formData.file.file);

  if (!formData.file.fileList.length) throw new Error();

  return await uploadInstance
    .post("documents/other", form, {
      params,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => res.data)
    .catch((e) => {
      throw e;
    });
};

const mutationFunction = async ({
  formData,
  companyId,
  documentType,
}: {
  formData: DocumentFormFields;
  companyId: number;
  documentType: string;
}) => {
  if (documentType === documentTypes[0]) {
    await uploadAgreementDocument(formData, companyId);
    return;
  }
  if (documentType === documentTypes[1]) {
    uploadProductDocument(formData, companyId);
    return;
  }

  await uploadOtherDocument(formData, companyId);
};

const useUploadDocument = () => {
  return useMutation({
    mutationFn: mutationFunction,
    mutationKey: ["documents"],
  });
};

export default useUploadDocument;
